export default __webpack_public_path__ + "static/media/victory.f1f96272.wav";